import { ArrowUpRight } from "lucide-react";

export default function ProjectCard({ project, index }) {
    return (
        <article
            data-testid={`project-card-${project.id}`}
            className="project-card group relative overflow-hidden bg-charcoal-2 border border-[#1c1c1c] hover:border-[#3a3a3a] transition-colors"
        >
            <div className="aspect-[4/5] overflow-hidden">
                <img
                    src={project.image}
                    alt={project.name}
                    loading="lazy"
                    className="project-card-img w-full h-full object-cover"
                />
            </div>
            <div className="absolute top-4 left-4">
                <span className="text-xs font-mono text-cream bg-black/50 backdrop-blur px-3 py-1 tracking-widest">
                    {String(index + 1).padStart(2, "0")}
                </span>
            </div>
            <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-10 h-10 bg-gold text-charcoal flex items-center justify-center">
                    <ArrowUpRight size={18} />
                </div>
            </div>
            <div className="p-6 md:p-7 border-t border-[#1c1c1c]">
                <p className="overline mb-3">{project.type} · {project.year}</p>
                <h3 className="font-display text-2xl md:text-3xl text-cream leading-tight tracking-tight group-hover:text-gold transition-colors">
                    {project.name}
                </h3>
                <p className="mt-2 text-sm text-[#A3A3A3]">{project.city}</p>
            </div>
        </article>
    );
}
